import { render, staticRenderFns } from "./rfq-statewide-make.vue?vue&type=template&id=08c27019&scoped=true"
import script from "./rfq-statewide-make.vue?vue&type=script&lang=js"
export * from "./rfq-statewide-make.vue?vue&type=script&lang=js"
import style0 from "./rfq-statewide-make.vue?vue&type=style&index=0&id=08c27019&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c27019",
  null
  
)

export default component.exports